import el from "@cypherpotato/el";
import { api } from "../api";
import { runOperation } from "../ui/operation";
import { Icon } from "./icon";
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "./table";
import { MutedText } from "./text";
import { ellipsis } from "../util";

export function SkillPickerControl({ allowNone = false, multiple = false, value }) {

    const skills = el.state.create([]);

    // Para múltipla seleção, value é um array; para seleção única, é um único valor
    const selectedSkills = el.state.create(
        multiple
            ? (Array.isArray(value) ? value : (value ? [value] : []))
            : value
    );

    runOperation("Fetching skills...", async () => {
        const response = await api.getJson("/api/v1/skills");
        skills.value = response.data;
    });

    function isSelected(skillId) {
        if (multiple) {
            return selectedSkills.value.includes(skillId);
        }
        return selectedSkills.value === skillId;
    }

    function toggleSelection(skillId) {
        if (multiple) {
            const current = selectedSkills.value;
            if (current.includes(skillId)) {
                selectedSkills.value = current.filter(id => id !== skillId);
            } else {
                selectedSkills.value = [...current, skillId];
            }
        } else {
            selectedSkills.value = skillId;
        }
    }

    function clearSelection() {
        if (multiple) {
            selectedSkills.value = [];
        } else {
            selectedSkills.value = null;
        }
    }

    return el.state.listening([skills, selectedSkills], () =>
        Table(
            {
                $properties: {
                    value: {
                        get() {
                            return selectedSkills.value;
                        },
                        set(value) {
                            if (multiple) {
                                selectedSkills.value = Array.isArray(value) ? value : (value ? [value] : []);
                            } else {
                                selectedSkills.value = value;
                            }
                        }
                    }
                },
                classList: ["selectable"]
            },
            TableHeader(
                TableHeaderCell("Slug"),
                TableHeaderCell("Description")
            ),
            TableBody(
                allowNone && TableRow(
                    TableCell(MutedText(multiple ? "(Clear selection)" : "(None)")),
                    TableCell(),
                    {
                        onClick() {
                            clearSelection();
                        },
                        classList: [
                            (multiple ? selectedSkills.value.length === 0 : selectedSkills.value === null) && "highlighted"
                        ]
                    }
                ),
                skills.value.map(skill =>
                    TableRow(
                        TableCell(skill.slug),
                        TableCell(
                            el("div",
                                ellipsis(skill.description, 80),
                                el("span.highlighted-only.selected-icon",
                                    Icon("check-line")
                                ),
                            )
                        ),
                        {
                            onClick() {
                                toggleSelection(skill.id);
                            },
                            classList: [isSelected(skill.id) && "highlighted"]
                        }
                    )
                )
            )
        )
    );
}
